/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const cacheQuotaExceededErrorCode = "cache_quota_exceeded";
export const cacheUnknownErrorCode = "cache_error_unknown";
